import React from "react";
import { XP_ICON_SRC, formatXp } from "../../utils/xp";

type XpAmountProps = {
  value: number;
  iconClassName?: string;
  valueClassName?: string;
  className?: string;
};

/** XP icon + formatted amount (shared header / profile / career stats). */
export function XpAmount({
  value,
  iconClassName = "h-4 w-4 shrink-0 object-contain",
  valueClassName = "font-anton text-[10px] font-normal leading-[100%] tracking-normal text-white [leading-trim:none]",
  className = "inline-flex items-center gap-1",
}: XpAmountProps) {
  return (
    <span className={className}>
      <img src={XP_ICON_SRC} alt="" className={iconClassName} aria-hidden />
      <span className={`tabular-nums ${valueClassName}`}>{formatXp(value)}</span>
    </span>
  );
}
